//filter/dateFormat.js

function date(value = '') {
	value = '' + value;

	return value.split(' ')[0].replace(/-/g, '.');
}

export default date;
